import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home'
import Help from './views/Help'
import Login from './views/Login'
import Events from './views/Events'
import Tickets from './views/Tickets'
import Users from './views/Users'
import Devices from './views/Devices'
import EventBlocks from './views/EventBlocks'
import Statistics from './views/Statistics'
import Checkpoints from '@/views/Checkpoints'
import Ticketsets from "@/views/Ticketsets";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/events',
      name: 'events',
      component: Events
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/devices',
      name: 'devices',
      component: Devices
    },
    {
      path: '/checkpoints',
      name: 'checkpoints',
      component: Checkpoints
    },
    // {
    //   path: '/event-blocks',
    //   name: 'event-blocks',
    //   component: EventBlocks
    // },
    {
      path: '/ticketsets',
      name: 'ticketsets',
      component: Ticketsets
    },
    {
      path: '/tickets',
      name: 'tickets',
      component: Tickets
    },
    {
      path: '/stats',
      name: 'statistics',
      component: Statistics
    }
  ]
})
